import React from 'react';
const Loading = () => {
    return (React.createElement("div", { className: 'd-flex justify-content-center align-items-center' },
        React.createElement("i", { className: "fa fa-spinner fa-spin fa-fw" })));
};
export default Loading;
